import { Component,
         EventEmitter,
         Input,
         OnInit,
         OnDestroy,
         Output,
         ViewChild } from '@angular/core'

import { FormBuilder,
         FormGroup,
         FormArray,
         FormControl,
         Validators } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar'

import { ActivatedRoute,
         Router } from '@angular/router'

import { AuthService,
         CookieConsent,
         CookieService,
         RouterService,
         // ToastService,
         User } from 'src/app/_core/index'

import { RecaptchaInputComponent } from 'src/app/_shared/recaptcha-input/recaptcha-input.component' // '../../form/recaptcha-input/recaptcha-input.component'

@Component({
  moduleId: module.id,
  selector: 'ss-cookie-consent-form',
  templateUrl: 'cookie-consent-form.component.html',
  styleUrls: ['cookie-consent-form.component.scss']
})

export class CookieConsentFormComponent implements OnInit, OnDestroy {

  @Output() onComplete = new EventEmitter<boolean>()

  @ViewChild(RecaptchaInputComponent) recaptcha: RecaptchaInputComponent

  cookie$: any
  cookieConsent: CookieConsent = new CookieConsent()
  user$: any
  currentUser: User

  isSubmitting = false
  form: FormGroup
  checkboxGroup: any
  anyActiveCookieConsent = false

  constructor(
    private authService: AuthService,
    private cookieService: CookieService,
    private fb: FormBuilder,
    private matSnackbar: MatSnackBar,
    private router: Router,
    private routerService: RouterService,
    // private toast: ToastService
  ) {}

  ngOnInit() {
    this.cookieService.populateCookieConsentFromCookie()
    this.initForm()

    this.cookie$ = this.cookieService.cookieConsent.subscribe( (res:CookieConsent) => {
      this.cookieConsent = new CookieConsent(res)
      console.log('CHECK anyActiveCookieConsent', this.cookieConsent)
      this.anyActiveCookieConsent = this.cookieConsent.hasAttribute('necessary')
      if (!this.anyActiveCookieConsent) this.cookieConsent.fromDefault()

      this.updateFormFromCookieConsent()
    })

    this.user$ = this.authService.currentUser.subscribe( (u:User) => {
      this.currentUser = u
    })
  }

  setDefaultCookieConsent() {
    this.cookieConsent = new CookieConsent()
    this.cookieConsent.fromDefault()
  }

  updateFormFromCookieConsent() {
    this.form.setValue({
      'necessary': true,
      'performance': this.cookieConsent.performance ? true : false,
      'targeting': this.cookieConsent.targeting ? true : false,
    })
  }

  ngOnDestroy() {
    if (this.cookie$) this.cookie$.unsubscribe()
    if (this.user$) this.user$.unsubscribe()
  }

  initForm() {
    this.form = this.fb.group({
      'necessary': [''],
      'performance': [''],
      'targeting': ['']
    })

    this.form.controls['necessary'].setValue(true)
  }

  closeForm() {
  }

  onCancel() {
    this.routerService.navigateByUrl('/')
  }

  onCheckboxChange(event) {
    if (!this.form.get(event.target.id)) return
    this.form.patchValue({[event.target.id] : event.target.checked}) //make sure to have the square brackets
  }

  onSave() {
    let formValue = this.form.value
    formValue['updated_at'] = Date.now()

    this.cookieConsent = new CookieConsent(formValue)
    this.cookieService.setCookieConsent(this.cookieConsent)

    this.redirectAfterSave()
  }

  redirectAfterSave() {
    this.router.navigateByUrl('/')
    this.matSnackbar.open(`Your cookie preferences have been updated`, 'close', { duration: 5000 });
    // if (this.cookieConsent.allCookiesEnabled() && this.currentUser) {
    //   this.router.navigateByUrl('/')
    // } else if (this.currentUser) {
    //   console.log('ERR: YOU MUST ENABLE ALL COOIKIES TO BE LOGGED IN')
    //   // this.toast.error('You must enable all cookies to be logged in.', "Cookies needed!")
    // } else {
    //   this.router.navigateByUrl('/')
    // }
  }


  removeCookieConsent() {
    this.cookieService.removeCookieConsent()
    this.redirectAfterSave()
  }

  updateSubmitting(isSubmitting: boolean) {
    this.isSubmitting = isSubmitting
  }
}
